import { jsx as M, jsxs as Z, Fragment as nt } from "react/jsx-runtime";
import { useRef as le, useLayoutEffect as He, forwardRef as at, useState as ie, useCallback as z, useMemo as E, createElement as rt, useImperativeHandle as st, useEffect as de, memo as me } from "react";
import { t as it } from "./throttle-CbOTDqvg.mjs";
import { c as I } from "./tw-cn-mXgPecoF.mjs";
import { u as ot } from "./use-isomorphic-layout-effect-m4WLzKHG.mjs";
import { I as ct, a as ut } from "./ic_arrowforward_fill-DIQoCdSY.mjs";
import { I as Pe } from "./icon-button-UFwDzoPr.mjs";
function lt(t, e, n = "long") {
  return new Intl.DateTimeFormat("en-US", {
    // Enforces engine to render the time. Without the option JavaScriptCore omits it.
    hour: "numeric",
    timeZone: t,
    timeZoneName: n
  }).format(e).split(/\s/g).slice(2).join(" ");
}
const we = {}, se = {};
function Q(t, e) {
  try {
    const a = (we[t] || (we[t] = new Intl.DateTimeFormat("en-US", {
      timeZone: t,
      timeZoneName: "longOffset"
    }).format))(e).split("GMT")[1];
    return a in se ? se[a] : xe(a, a.split(":"));
  } catch {
    if (t in se) return se[t];
    const n = t == null ? void 0 : t.match(dt);
    return n ? xe(t, n.slice(1)) : NaN;
  }
}
const dt = /([+-]\d\d):?(\d\d)?/;
function xe(t, e) {
  const n = +(e[0] || 0), a = +(e[1] || 0), r = +(e[2] || 0) / 60;
  return se[t] = n * 60 + a > 0 ? n * 60 + a + r : n * 60 - a - r;
}
class _ extends Date {
  //#region static
  constructor(...e) {
    super(), e.length > 1 && typeof e[e.length - 1] == "string" && (this.timeZone = e.pop()), this.internal = /* @__PURE__ */ new Date(), isNaN(Q(this.timeZone, this)) ? this.setTime(NaN) : e.length ? typeof e[0] == "number" && (e.length === 1 || e.length === 2 && typeof e[1] != "number") ? this.setTime(e[0]) : typeof e[0] == "string" ? this.setTime(+new Date(e[0])) : e[0] instanceof Date ? this.setTime(+e[0]) : (this.setTime(+new Date(...e)), Le(this), Se(this)) : this.setTime(Date.now());
  }
  static tz(e, ...n) {
    return n.length ? new _(...n, e) : new _(Date.now(), e);
  }
  //#endregion
  //#region time zone
  withTimeZone(e) {
    return new _(+this, e);
  }
  getTimezoneOffset() {
    const e = -Q(this.timeZone, this);
    return e > 0 ? Math.floor(e) : Math.ceil(e);
  }
  //#endregion
  //#region time
  setTime(e) {
    return Date.prototype.setTime.apply(this, arguments), Se(this), +this;
  }
  //#endregion
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](e) {
    return new _(+new Date(e), this.timeZone);
  }
  //#endregion
}
const Ne = /^(get|set)(?!UTC)/;
Object.getOwnPropertyNames(Date.prototype).forEach((t) => {
  if (!Ne.test(t)) return;
  const e = t.replace(Ne, "$1UTC");
  _.prototype[e] && (t.startsWith("get") ? _.prototype[t] = function() {
    return this.internal[e]();
  } : (_.prototype[t] = function() {
    return Date.prototype[e].apply(this.internal, arguments), ft(this), +this;
  }, _.prototype[e] = function() {
    return Date.prototype[e].apply(this, arguments), Se(this), +this;
  }));
});
function Se(t) {
  t.internal.setTime(+t), t.internal.setUTCSeconds(t.internal.getUTCSeconds() - Math.round(-Q(t.timeZone, t) * 60));
}
function ft(t) {
  Date.prototype.setFullYear.call(t, t.internal.getUTCFullYear(), t.internal.getUTCMonth(), t.internal.getUTCDate()), Date.prototype.setHours.call(t, t.internal.getUTCHours(), t.internal.getUTCMinutes(), t.internal.getUTCSeconds(), t.internal.getUTCMilliseconds()), Le(t);
}
function Le(t) {
  const e = Q(t.timeZone, t), n = e > 0 ? Math.floor(e) : Math.ceil(e), a = /* @__PURE__ */ new Date(+t);
  a.setUTCHours(a.getUTCHours() - 1);
  const r = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset(), i = -(/* @__PURE__ */ new Date(+a)).getTimezoneOffset(), c = r - i, s = Date.prototype.getHours.apply(t) !== t.internal.getUTCHours();
  c && s && t.internal.setUTCMinutes(t.internal.getUTCMinutes() + c);
  const f = r - n;
  f && Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + f);
  const o = /* @__PURE__ */ new Date(+t);
  o.setUTCSeconds(0);
  const l = r > 0 ? o.getSeconds() : (o.getSeconds() - 60) % 60, u = Math.round(-(Q(t.timeZone, t) * 60)) % 60;
  (u || l) && (t.internal.setUTCSeconds(t.internal.getUTCSeconds() + u), Date.prototype.setUTCSeconds.call(t, Date.prototype.getUTCSeconds.call(t) + u + l));
  const h = Q(t.timeZone, t), d = h > 0 ? Math.floor(h) : Math.ceil(h), g = -(/* @__PURE__ */ new Date(+t)).getTimezoneOffset() - d, D = d !== n, k = g - f;
  if (D && k) {
    Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + k);
    const y = Q(t.timeZone, t), v = y > 0 ? Math.floor(y) : Math.ceil(y), N = d - v;
    N && (t.internal.setUTCMinutes(t.internal.getUTCMinutes() + N), Date.prototype.setUTCMinutes.call(t, Date.prototype.getUTCMinutes.call(t) + N));
  }
}
class G extends _ {
  //#region static
  static tz(e, ...n) {
    return n.length ? new G(...n, e) : new G(Date.now(), e);
  }
  //#endregion
  //#region representation
  toISOString() {
    const [e, n, a] = this.tzComponents(), r = `${e}${n}:${a}`;
    return this.internal.toISOString().slice(0, -1) + r;
  }
  toString() {
    return `${this.toDateString()} ${this.toTimeString()}`;
  }
  toDateString() {
    const [e, n, a, r] = this.internal.toUTCString().split(" ");
    return `${e == null ? void 0 : e.slice(0, -1)} ${a} ${n} ${r}`;
  }
  toTimeString() {
    const e = this.internal.toUTCString().split(" ")[4], [n, a, r] = this.tzComponents();
    return `${e} GMT${n}${a}${r} (${lt(this.timeZone, this)})`;
  }
  toLocaleString(e, n) {
    return Date.prototype.toLocaleString.call(this, e, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleDateString(e, n) {
    return Date.prototype.toLocaleDateString.call(this, e, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  toLocaleTimeString(e, n) {
    return Date.prototype.toLocaleTimeString.call(this, e, {
      ...n,
      timeZone: (n == null ? void 0 : n.timeZone) || this.timeZone
    });
  }
  //#endregion
  //#region private
  tzComponents() {
    const e = this.getTimezoneOffset(), n = e > 0 ? "-" : "+", a = String(Math.floor(Math.abs(e) / 60)).padStart(2, "0"), r = String(Math.abs(e) % 60).padStart(2, "0");
    return [n, a, r];
  }
  //#endregion
  withTimeZone(e) {
    return new G(+this, e);
  }
  //#region date-fns integration
  [Symbol.for("constructDateFrom")](e) {
    return new G(+new Date(e), this.timeZone);
  }
  //#endregion
}
const _e = 6048e5, ht = 864e5, Ue = 6e4, je = 36e5, Ce = Symbol.for("constructDateFrom");
function p(t, e) {
  return typeof t == "function" ? t(e) : t && typeof t == "object" && Ce in t ? t[Ce](e) : t instanceof Date ? new t.constructor(e) : new Date(e);
}
function x(t, e) {
  return p(e || t, t);
}
function J(t, e, n) {
  const a = x(t, n == null ? void 0 : n.in);
  return isNaN(e) ? p(t, NaN) : (e && a.setDate(a.getDate() + e), a);
}
function mt(t, e, n) {
  const a = x(t, n == null ? void 0 : n.in);
  if (isNaN(e)) return p(t, NaN);
  if (!e)
    return a;
  const r = a.getDate(), i = p(t, a.getTime());
  i.setMonth(a.getMonth() + e + 1, 0);
  const c = i.getDate();
  return r >= c ? i : (a.setFullYear(
    i.getFullYear(),
    i.getMonth(),
    r
  ), a);
}
let gt = {};
function ge() {
  return gt;
}
function ce(t, e) {
  var s, f, o, l;
  const n = ge(), a = (e == null ? void 0 : e.weekStartsOn) ?? ((f = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : f.weekStartsOn) ?? n.weekStartsOn ?? ((l = (o = n.locale) == null ? void 0 : o.options) == null ? void 0 : l.weekStartsOn) ?? 0, r = x(t, e == null ? void 0 : e.in), i = r.getDay(), c = (i < a ? 7 : 0) + i - a;
  return r.setDate(r.getDate() - c), r.setHours(0, 0, 0, 0), r;
}
function fe(t, e) {
  return ce(t, { ...e, weekStartsOn: 1 });
}
function Ae(t, e) {
  const n = x(t, e == null ? void 0 : e.in), a = n.getFullYear(), r = p(n, 0);
  r.setFullYear(a + 1, 0, 4), r.setHours(0, 0, 0, 0);
  const i = fe(r), c = p(n, 0);
  c.setFullYear(a, 0, 4), c.setHours(0, 0, 0, 0);
  const s = fe(c);
  return n.getTime() >= i.getTime() ? a + 1 : n.getTime() >= s.getTime() ? a : a - 1;
}
function ke(t) {
  const e = x(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function Oe(t, ...e) {
  const n = p.bind(
    null,
    e.find((a) => typeof a == "object")
  );
  return e.map(n);
}
function he(t, e) {
  const n = x(t, e == null ? void 0 : e.in);
  return n.setHours(0, 0, 0, 0), n;
}
function Me(t, e, n) {
  const [a, r] = Oe(
    n == null ? void 0 : n.in,
    t,
    e
  ), i = he(a), c = he(r), s = +i - ke(i), f = +c - ke(c);
  return Math.round((s - f) / ht);
}
function yt(t, e) {
  const n = Ae(t, e), a = p(t, 0);
  return a.setFullYear(n, 0, 4), a.setHours(0, 0, 0, 0), fe(a);
}
function X(t, e, n) {
  const [a, r] = Oe(
    n == null ? void 0 : n.in,
    t,
    e
  );
  return +he(a) == +he(r);
}
function wt(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function bt(t) {
  return !(!wt(t) && typeof t != "number" || isNaN(+x(t)));
}
function Dt(t, e, n) {
  const [a, r] = Oe(
    n == null ? void 0 : n.in,
    t,
    e
  ), i = a.getFullYear() - r.getFullYear(), c = a.getMonth() - r.getMonth();
  return i * 12 + c;
}
function Tt(t, e) {
  const n = x(t, e == null ? void 0 : e.in), a = n.getMonth();
  return n.setFullYear(n.getFullYear(), a + 1, 0), n.setHours(23, 59, 59, 999), n;
}
function be(t, e) {
  const n = x(t, e == null ? void 0 : e.in);
  return n.setDate(1), n.setHours(0, 0, 0, 0), n;
}
function St(t, e) {
  const n = x(t, e == null ? void 0 : e.in);
  return n.setFullYear(n.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
const Mt = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Ot = (t, e, n) => {
  let a;
  const r = Mt[t];
  return typeof r == "string" ? a = r : e === 1 ? a = r.one : a = r.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + a : a + " ago" : a;
};
function te(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const vt = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Pt = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, xt = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Nt = {
  date: te({
    formats: vt,
    defaultWidth: "full"
  }),
  time: te({
    formats: Pt,
    defaultWidth: "full"
  }),
  dateTime: te({
    formats: xt,
    defaultWidth: "full"
  })
}, Ct = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, kt = (t, e, n, a) => Ct[t];
function H(t) {
  return (e, n) => {
    const a = n != null && n.context ? String(n.context) : "standalone";
    let r;
    if (a === "formatting" && t.formattingValues) {
      const c = t.defaultFormattingWidth || t.defaultWidth, s = n != null && n.width ? String(n.width) : c;
      r = t.formattingValues[s] || t.formattingValues[c];
    } else {
      const c = t.defaultWidth, s = n != null && n.width ? String(n.width) : t.defaultWidth;
      r = t.values[s] || t.values[c];
    }
    const i = t.argumentCallback ? t.argumentCallback(e) : e;
    return r[i];
  };
}
const Wt = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, Yt = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, Ft = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, Et = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, pt = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, $t = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, It = (t, e) => {
  const n = Number(t), a = n % 100;
  if (a > 20 || a < 10)
    switch (a % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, Ht = {
  ordinalNumber: It,
  era: H({
    values: Wt,
    defaultWidth: "wide"
  }),
  quarter: H({
    values: Yt,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: H({
    values: Ft,
    defaultWidth: "wide"
  }),
  day: H({
    values: Et,
    defaultWidth: "wide"
  }),
  dayPeriod: H({
    values: pt,
    defaultWidth: "wide",
    formattingValues: $t,
    defaultFormattingWidth: "wide"
  })
};
function L(t) {
  return (e, n = {}) => {
    const a = n.width, r = a && t.matchPatterns[a] || t.matchPatterns[t.defaultMatchWidth], i = e.match(r);
    if (!i)
      return null;
    const c = i[0], s = a && t.parsePatterns[a] || t.parsePatterns[t.defaultParseWidth], f = Array.isArray(s) ? _t(s, (u) => u.test(c)) : (
      // [TODO] -- I challenge you to fix the type
      Lt(s, (u) => u.test(c))
    );
    let o;
    o = t.valueCallback ? t.valueCallback(f) : f, o = n.valueCallback ? (
      // [TODO] -- I challenge you to fix the type
      n.valueCallback(o)
    ) : o;
    const l = e.slice(c.length);
    return { value: o, rest: l };
  };
}
function Lt(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function _t(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function Re(t) {
  return (e, n = {}) => {
    const a = e.match(t.matchPattern);
    if (!a) return null;
    const r = a[0], i = e.match(t.parsePattern);
    if (!i) return null;
    let c = t.valueCallback ? t.valueCallback(i[0]) : i[0];
    c = n.valueCallback ? n.valueCallback(c) : c;
    const s = e.slice(r.length);
    return { value: c, rest: s };
  };
}
const Ut = /^(\d+)(th|st|nd|rd)?/i, jt = /\d+/i, At = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, Rt = {
  any: [/^b/i, /^(a|c)/i]
}, qt = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, zt = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Bt = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, Vt = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Xt = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, Qt = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Gt = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, Zt = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, Jt = {
  ordinalNumber: Re({
    matchPattern: Ut,
    parsePattern: jt,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: L({
    matchPatterns: At,
    defaultMatchWidth: "wide",
    parsePatterns: Rt,
    defaultParseWidth: "any"
  }),
  quarter: L({
    matchPatterns: qt,
    defaultMatchWidth: "wide",
    parsePatterns: zt,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: L({
    matchPatterns: Bt,
    defaultMatchWidth: "wide",
    parsePatterns: Vt,
    defaultParseWidth: "any"
  }),
  day: L({
    matchPatterns: Xt,
    defaultMatchWidth: "wide",
    parsePatterns: Qt,
    defaultParseWidth: "any"
  }),
  dayPeriod: L({
    matchPatterns: Gt,
    defaultMatchWidth: "any",
    parsePatterns: Zt,
    defaultParseWidth: "any"
  })
}, Kt = {
  code: "en-US",
  formatDistance: Ot,
  formatLong: Nt,
  formatRelative: kt,
  localize: Ht,
  match: Jt,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function en(t, e) {
  const n = x(t, e == null ? void 0 : e.in);
  return Me(n, St(n)) + 1;
}
function tn(t, e) {
  const n = x(t, e == null ? void 0 : e.in), a = +fe(n) - +yt(n);
  return Math.round(a / _e) + 1;
}
function qe(t, e) {
  var l, u, h, d;
  const n = x(t, e == null ? void 0 : e.in), a = n.getFullYear(), r = ge(), i = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((u = (l = e == null ? void 0 : e.locale) == null ? void 0 : l.options) == null ? void 0 : u.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((d = (h = r.locale) == null ? void 0 : h.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, c = p((e == null ? void 0 : e.in) || t, 0);
  c.setFullYear(a + 1, 0, i), c.setHours(0, 0, 0, 0);
  const s = ce(c, e), f = p((e == null ? void 0 : e.in) || t, 0);
  f.setFullYear(a, 0, i), f.setHours(0, 0, 0, 0);
  const o = ce(f, e);
  return +n >= +s ? a + 1 : +n >= +o ? a : a - 1;
}
function nn(t, e) {
  var s, f, o, l;
  const n = ge(), a = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((f = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : f.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((l = (o = n.locale) == null ? void 0 : o.options) == null ? void 0 : l.firstWeekContainsDate) ?? 1, r = qe(t, e), i = p((e == null ? void 0 : e.in) || t, 0);
  return i.setFullYear(r, 0, a), i.setHours(0, 0, 0, 0), ce(i, e);
}
function an(t, e) {
  const n = x(t, e == null ? void 0 : e.in), a = +ce(n, e) - +nn(n, e);
  return Math.round(a / _e) + 1;
}
function S(t, e) {
  const n = t < 0 ? "-" : "", a = Math.abs(t).toString().padStart(e, "0");
  return n + a;
}
const q = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), a = n > 0 ? n : 1 - n;
    return S(e === "yy" ? a % 100 : a, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : S(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return S(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return S(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return S(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return S(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return S(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, a = t.getMilliseconds(), r = Math.trunc(
      a * Math.pow(10, n - 3)
    );
    return S(r, e.length);
  }
}, ee = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, We = {
  // Era
  G: function(t, e, n) {
    const a = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      case "G":
      case "GG":
      case "GGG":
        return n.era(a, { width: "abbreviated" });
      case "GGGGG":
        return n.era(a, { width: "narrow" });
      case "GGGG":
      default:
        return n.era(a, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const a = t.getFullYear(), r = a > 0 ? a : 1 - a;
      return n.ordinalNumber(r, { unit: "year" });
    }
    return q.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, a) {
    const r = qe(t, a), i = r > 0 ? r : 1 - r;
    if (e === "YY") {
      const c = i % 100;
      return S(c, 2);
    }
    return e === "Yo" ? n.ordinalNumber(i, { unit: "year" }) : S(i, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = Ae(t);
    return S(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return S(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const a = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "Q":
        return String(a);
      case "QQ":
        return S(a, 2);
      case "Qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      case "QQQ":
        return n.quarter(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "QQQQQ":
        return n.quarter(a, {
          width: "narrow",
          context: "formatting"
        });
      case "QQQQ":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const a = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      case "q":
        return String(a);
      case "qq":
        return S(a, 2);
      case "qo":
        return n.ordinalNumber(a, { unit: "quarter" });
      case "qqq":
        return n.quarter(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "qqqqq":
        return n.quarter(a, {
          width: "narrow",
          context: "standalone"
        });
      case "qqqq":
      default:
        return n.quarter(a, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const a = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return q.M(t, e);
      case "Mo":
        return n.ordinalNumber(a + 1, { unit: "month" });
      case "MMM":
        return n.month(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "MMMMM":
        return n.month(a, {
          width: "narrow",
          context: "formatting"
        });
      case "MMMM":
      default:
        return n.month(a, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const a = t.getMonth();
    switch (e) {
      case "L":
        return String(a + 1);
      case "LL":
        return S(a + 1, 2);
      case "Lo":
        return n.ordinalNumber(a + 1, { unit: "month" });
      case "LLL":
        return n.month(a, {
          width: "abbreviated",
          context: "standalone"
        });
      case "LLLLL":
        return n.month(a, {
          width: "narrow",
          context: "standalone"
        });
      case "LLLL":
      default:
        return n.month(a, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, a) {
    const r = an(t, a);
    return e === "wo" ? n.ordinalNumber(r, { unit: "week" }) : S(r, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const a = tn(t);
    return e === "Io" ? n.ordinalNumber(a, { unit: "week" }) : S(a, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : q.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const a = en(t);
    return e === "Do" ? n.ordinalNumber(a, { unit: "dayOfYear" }) : S(a, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const a = t.getDay();
    switch (e) {
      case "E":
      case "EE":
      case "EEE":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "EEEEE":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "EEEEEE":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "EEEE":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, a) {
    const r = t.getDay(), i = (r - a.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "e":
        return String(i);
      case "ee":
        return S(i, 2);
      case "eo":
        return n.ordinalNumber(i, { unit: "day" });
      case "eee":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "eeeee":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      case "eeeeee":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      case "eeee":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, a) {
    const r = t.getDay(), i = (r - a.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      case "c":
        return String(i);
      case "cc":
        return S(i, e.length);
      case "co":
        return n.ordinalNumber(i, { unit: "day" });
      case "ccc":
        return n.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      case "ccccc":
        return n.day(r, {
          width: "narrow",
          context: "standalone"
        });
      case "cccccc":
        return n.day(r, {
          width: "short",
          context: "standalone"
        });
      case "cccc":
      default:
        return n.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const a = t.getDay(), r = a === 0 ? 7 : a;
    switch (e) {
      case "i":
        return String(r);
      case "ii":
        return S(r, e.length);
      case "io":
        return n.ordinalNumber(r, { unit: "day" });
      case "iii":
        return n.day(a, {
          width: "abbreviated",
          context: "formatting"
        });
      case "iiiii":
        return n.day(a, {
          width: "narrow",
          context: "formatting"
        });
      case "iiiiii":
        return n.day(a, {
          width: "short",
          context: "formatting"
        });
      case "iiii":
      default:
        return n.day(a, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const r = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const a = t.getHours();
    let r;
    switch (a === 12 ? r = ee.noon : a === 0 ? r = ee.midnight : r = a / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const a = t.getHours();
    let r;
    switch (a >= 17 ? r = ee.evening : a >= 12 ? r = ee.afternoon : a >= 4 ? r = ee.morning : r = ee.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let a = t.getHours() % 12;
      return a === 0 && (a = 12), n.ordinalNumber(a, { unit: "hour" });
    }
    return q.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : q.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const a = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(a, { unit: "hour" }) : S(a, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let a = t.getHours();
    return a === 0 && (a = 24), e === "ko" ? n.ordinalNumber(a, { unit: "hour" }) : S(a, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : q.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : q.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return q.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const a = t.getTimezoneOffset();
    if (a === 0)
      return "Z";
    switch (e) {
      case "X":
        return Fe(a);
      case "XXXX":
      case "XX":
        return V(a);
      case "XXXXX":
      case "XXX":
      default:
        return V(a, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const a = t.getTimezoneOffset();
    switch (e) {
      case "x":
        return Fe(a);
      case "xxxx":
      case "xx":
        return V(a);
      case "xxxxx":
      case "xxx":
      default:
        return V(a, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const a = t.getTimezoneOffset();
    switch (e) {
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + Ye(a, ":");
      case "OOOO":
      default:
        return "GMT" + V(a, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const a = t.getTimezoneOffset();
    switch (e) {
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + Ye(a, ":");
      case "zzzz":
      default:
        return "GMT" + V(a, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const a = Math.trunc(+t / 1e3);
    return S(a, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    return S(+t, e.length);
  }
};
function Ye(t, e = "") {
  const n = t > 0 ? "-" : "+", a = Math.abs(t), r = Math.trunc(a / 60), i = a % 60;
  return i === 0 ? n + String(r) : n + String(r) + e + S(i, 2);
}
function Fe(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + S(Math.abs(t) / 60, 2) : V(t, e);
}
function V(t, e = "") {
  const n = t > 0 ? "-" : "+", a = Math.abs(t), r = S(Math.trunc(a / 60), 2), i = S(a % 60, 2);
  return n + r + e + i;
}
const Ee = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, ze = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, rn = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], a = n[1], r = n[2];
  if (!r)
    return Ee(t, e);
  let i;
  switch (a) {
    case "P":
      i = e.dateTime({ width: "short" });
      break;
    case "PP":
      i = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      i = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      i = e.dateTime({ width: "full" });
      break;
  }
  return i.replace("{{date}}", Ee(a, e)).replace("{{time}}", ze(r, e));
}, sn = {
  p: ze,
  P: rn
}, on = /^D+$/, cn = /^Y+$/, un = ["D", "DD", "YY", "YYYY"];
function ln(t) {
  return on.test(t);
}
function dn(t) {
  return cn.test(t);
}
function fn(t, e, n) {
  const a = hn(t, e, n);
  if (console.warn(a), un.includes(t)) throw new RangeError(a);
}
function hn(t, e, n) {
  const a = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${a} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const mn = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, gn = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, yn = /^'([^]*?)'?$/, wn = /''/g, bn = /[a-zA-Z]/;
function ne(t, e, n) {
  var l, u, h, d, m, g, D, k;
  const a = ge(), r = (n == null ? void 0 : n.locale) ?? a.locale ?? Kt, i = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((u = (l = n == null ? void 0 : n.locale) == null ? void 0 : l.options) == null ? void 0 : u.firstWeekContainsDate) ?? a.firstWeekContainsDate ?? ((d = (h = a.locale) == null ? void 0 : h.options) == null ? void 0 : d.firstWeekContainsDate) ?? 1, c = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (m = n == null ? void 0 : n.locale) == null ? void 0 : m.options) == null ? void 0 : g.weekStartsOn) ?? a.weekStartsOn ?? ((k = (D = a.locale) == null ? void 0 : D.options) == null ? void 0 : k.weekStartsOn) ?? 0, s = x(t, n == null ? void 0 : n.in);
  if (!bt(s))
    throw new RangeError("Invalid time value");
  let f = e.match(gn).map((y) => {
    const v = y[0];
    if (v === "p" || v === "P") {
      const N = sn[v];
      return N(y, r.formatLong);
    }
    return y;
  }).join("").match(mn).map((y) => {
    if (y === "''")
      return { isToken: !1, value: "'" };
    const v = y[0];
    if (v === "'")
      return { isToken: !1, value: Dn(y) };
    if (We[v])
      return { isToken: !0, value: y };
    if (v.match(bn))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + v + "`"
      );
    return { isToken: !1, value: y };
  });
  r.localize.preprocessor && (f = r.localize.preprocessor(s, f));
  const o = {
    firstWeekContainsDate: i,
    weekStartsOn: c,
    locale: r
  };
  return f.map((y) => {
    if (!y.isToken) return y.value;
    const v = y.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && dn(v) || !(n != null && n.useAdditionalDayOfYearTokens) && ln(v)) && fn(v, e, String(t));
    const N = We[v[0]];
    return N(s, v, r.localize, o);
  }).join("");
}
function Dn(t) {
  const e = t.match(yn);
  return e ? e[1].replace(wn, "'") : t;
}
function De(t, e) {
  return +x(t) > +x(e);
}
function oe(t, e) {
  return +x(t) < +x(e);
}
function pe(t, e) {
  return +x(t) == +x(e);
}
function Tn(t, e, n) {
  return J(t, -1, n);
}
function Be(t, e) {
  const n = () => p(e == null ? void 0 : e.in, NaN), r = vn(t);
  let i;
  if (r.date) {
    const o = Pn(r.date, 2);
    i = xn(o.restDateString, o.year);
  }
  if (!i || isNaN(+i)) return n();
  const c = +i;
  let s = 0, f;
  if (r.time && (s = Nn(r.time), isNaN(s)))
    return n();
  if (r.timezone) {
    if (f = Cn(r.timezone), isNaN(f)) return n();
  } else {
    const o = new Date(c + s), l = x(0, e == null ? void 0 : e.in);
    return l.setFullYear(
      o.getUTCFullYear(),
      o.getUTCMonth(),
      o.getUTCDate()
    ), l.setHours(
      o.getUTCHours(),
      o.getUTCMinutes(),
      o.getUTCSeconds(),
      o.getUTCMilliseconds()
    ), l;
  }
  return x(c + s + f, e == null ? void 0 : e.in);
}
const ue = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, Sn = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, Mn = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, On = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function vn(t) {
  const e = {}, n = t.split(ue.dateTimeDelimiter);
  let a;
  if (n.length > 2)
    return e;
  if (/:/.test(n[0]) ? a = n[0] : (e.date = n[0], a = n[1], ue.timeZoneDelimiter.test(e.date) && (e.date = t.split(ue.timeZoneDelimiter)[0], a = t.substr(
    e.date.length,
    t.length
  ))), a) {
    const r = ue.timezone.exec(a);
    r ? (e.time = a.replace(r[1], ""), e.timezone = r[1]) : e.time = a;
  }
  return e;
}
function Pn(t, e) {
  const n = new RegExp(
    "^(?:(\\d{4}|[+-]\\d{" + (4 + e) + "})|(\\d{2}|[+-]\\d{" + (2 + e) + "})$)"
  ), a = t.match(n);
  if (!a) return { year: NaN, restDateString: "" };
  const r = a[1] ? parseInt(a[1]) : null, i = a[2] ? parseInt(a[2]) : null;
  return {
    year: i === null ? r : i * 100,
    restDateString: t.slice((a[1] || a[2]).length)
  };
}
function xn(t, e) {
  if (e === null) return /* @__PURE__ */ new Date(NaN);
  const n = t.match(Sn);
  if (!n) return /* @__PURE__ */ new Date(NaN);
  const a = !!n[4], r = re(n[1]), i = re(n[2]) - 1, c = re(n[3]), s = re(n[4]), f = re(n[5]) - 1;
  if (a)
    return En(e, s, f) ? kn(e, s, f) : /* @__PURE__ */ new Date(NaN);
  {
    const o = /* @__PURE__ */ new Date(0);
    return !Yn(e, i, c) || !Fn(e, r) ? /* @__PURE__ */ new Date(NaN) : (o.setUTCFullYear(e, i, Math.max(r, c)), o);
  }
}
function re(t) {
  return t ? parseInt(t) : 1;
}
function Nn(t) {
  const e = t.match(Mn);
  if (!e) return NaN;
  const n = Te(e[1]), a = Te(e[2]), r = Te(e[3]);
  return pn(n, a, r) ? n * je + a * Ue + r * 1e3 : NaN;
}
function Te(t) {
  return t && parseFloat(t.replace(",", ".")) || 0;
}
function Cn(t) {
  if (t === "Z") return 0;
  const e = t.match(On);
  if (!e) return 0;
  const n = e[1] === "+" ? -1 : 1, a = parseInt(e[2]), r = e[3] && parseInt(e[3]) || 0;
  return $n(a, r) ? n * (a * je + r * Ue) : NaN;
}
function kn(t, e, n) {
  const a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(t, 0, 4);
  const r = a.getUTCDay() || 7, i = (e - 1) * 7 + n + 1 - r;
  return a.setUTCDate(a.getUTCDate() + i), a;
}
const Wn = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function Ve(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
function Yn(t, e, n) {
  return e >= 0 && e <= 11 && n >= 1 && n <= (Wn[e] || (Ve(t) ? 29 : 28));
}
function Fn(t, e) {
  return e >= 1 && e <= (Ve(t) ? 366 : 365);
}
function En(t, e, n) {
  return e >= 1 && e <= 53 && n >= 0 && n <= 6;
}
function pn(t, e, n) {
  return t === 24 ? e === 0 && n === 0 : n >= 0 && n < 60 && e >= 0 && e < 60 && t >= 0 && t < 25;
}
function $n(t, e) {
  return e >= 0 && e <= 59;
}
const Xe = (t) => {
  const e = le(null);
  return He(() => {
    var a, r;
    if (t.height !== null && t.height !== void 0)
      return;
    const n = (a = e.current) == null ? void 0 : a.getBoundingClientRect().height;
    n && ((r = t.updateHeight) == null || r.call(t, n, t.index));
  }, [t]), /* @__PURE__ */ M(
    "div",
    {
      className: `absolute w-full ${t.isVisible ? "visible" : "invisible"}`,
      ref: e,
      style: { top: `${t.offsetTop}px` },
      children: t.render()
    }
  );
};
Xe.displayName = "NDS.VirtualListItem";
const Qe = at(
  ({
    items: t,
    listHeight: e,
    updateHeight: n,
    preLoadingThreshold: a = 50,
    updateInterval: r = 80,
    scrollRef: i,
    footer: c,
    header: s,
    className: f,
    ...o
  }, l) => {
    const [u, h] = ie([]), d = le(), [m, g] = ie(0), [D, k] = ie(e || 0), y = le(null), v = z(
      (() => {
        const w = it(g, r, {
          leading: !0,
          trailing: !0
        });
        return (b) => {
          const T = b.currentTarget.scrollTop;
          w(T);
        };
      })(),
      [r]
    ), N = E(() => {
      if (u.length === 0)
        return;
      const w = a, b = Math.max(
        0,
        u.findIndex((O) => O >= m - w)
      ), T = u.findIndex((O) => O >= m + D + w, b), F = t.slice(b, T < 0 ? t.length : T), U = u.slice(b, T < 0 ? t.length : T), K = u.length === 1 || u.length > 1 && u.some((O) => O !== 0);
      return F.map((O, C) => /* @__PURE__ */ rt(
        Xe,
        {
          ...O,
          index: b + C,
          isVisible: K,
          key: C,
          offsetTop: U[C],
          updateHeight: n
        },
        O.render()
      ));
    }, [t, u, m, D, n, a]);
    return st(
      i,
      () => ({
        scrollByItemIndex: async (w, b = 0) => {
          await new Promise((T) => {
            setTimeout(() => {
              T();
            }, 0);
          }), y.current && d.current && (y.current.scrollTop = d.current[w] + b);
        }
      }),
      [u]
    ), He(() => {
      const w = t.reduce(
        (b, T) => (b.currentOffset += T.height || 0, b.offsetList.push(b.currentOffset), b),
        { currentOffset: 0, offsetList: [0] }
      );
      h(w.offsetList), d.current = w.offsetList;
    }, [t]), de(() => {
      const w = () => {
        var b;
        k(((b = y.current) == null ? void 0 : b.getBoundingClientRect().height) || 0);
      };
      return w(), window.addEventListener("resize", w), () => {
        window.removeEventListener("resize", w);
      };
    }, []), /* @__PURE__ */ Z(
      "div",
      {
        ...o,
        className: I("relative size-full overflow-y-auto", f),
        onScroll: (w) => {
          var b;
          (b = o.onScroll) == null || b.call(o, w), v(w);
        },
        ref: (w) => {
          w && (y.current = w, l && typeof l != "string" && "current" in l && (l.current = w));
        },
        children: [
          s,
          /* @__PURE__ */ M("div", { style: { height: `${e}px`, width: "100%" }, children: N }),
          c
        ]
      }
    );
  }
);
Qe.displayName = "NDS.VirtualList";
const In = ["일", "월", "화", "수", "목", "금", "토"], Ge = ({ deviceType: t, className: e }) => {
  const n = t === "etc";
  return /* @__PURE__ */ M("div", { className: I("grid min-h-32 grid-cols-7 text-text-neutral-main", e), children: In.map((a, r) => /* @__PURE__ */ M(
    "div",
    {
      className: I("px-18 py-6 text-center", n ? "typography-body-14-regular" : "typography-body-13-regular"),
      children: a
    },
    `${a}_${r}`
  )) });
};
Ge.displayName = "NDS.DayPickerWeeks";
const Hn = ({ type: t, className: e }) => /* @__PURE__ */ M(nt, { children: t === "start" ? /* @__PURE__ */ M(
  "svg",
  {
    className: e,
    fill: "none",
    height: "36",
    viewBox: "0 0 40 36",
    width: "40",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ M(
      "path",
      {
        d: "M0 8C0 3.58172 3.58172 0 8 0H25.7782C28.8039 0 31.5707 1.70699 32.928 4.41112L40 18.5L32.9691 31.7499C31.5814 34.365 28.8629 36 25.9024 36H8C3.58172 36 0 32.4183 0 28V8Z",
        fill: "#1B1C1F"
      }
    )
  }
) : /* @__PURE__ */ M(
  "svg",
  {
    className: e,
    fill: "none",
    height: "36",
    viewBox: "0 0 40 36",
    width: "40",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ M(
      "path",
      {
        d: "M40 8C40 3.58172 36.4183 0 32 0H14.2218C11.1961 0 8.42931 1.70699 7.07196 4.41112L0 18.5L7.03086 31.7499C8.41856 34.365 11.1371 36 14.0976 36H32C36.4183 36 40 32.4183 40 28V8Z",
        fill: "#1B1C1F",
        id: "Selected"
      }
    )
  }
) }), Ze = (t) => {
  const { day: e, isPc: n, className: a, dayDescriptions: r, onSelectDate: i } = t, { date: c, dateType: s, dateObject: f, isSelected: o, isFirstSelected: l, isLastSelected: u, isToday: h, disabled: d } = e, m = E(() => s === "sunday" || s === "holiday", [s]), g = E(() => s === "empty", [s]), D = E(() => g ? "" : l && (r != null && r[0]) ? r[0] : u && (r != null && r[1]) ? r[1] : e.text, [g, l, r, u, e.text]), k = z(() => {
    i == null || i(f);
  }, [f, i]);
  return /* @__PURE__ */ Z(
    "div",
    {
      className: "relative flex w-full min-w-40 flex-col items-center justify-center",
      "data-datetype": s,
      "data-day": f ? ne(f, "yyyy-MM-dd") : void 0,
      "data-disabled": d || void 0,
      "data-month": f ? ne(f, "yyyy-MM") : void 0,
      "data-selected": o || void 0,
      "data-today": h,
      children: [
        /* @__PURE__ */ M(
          "div",
          {
            className: I("absolute left-0 right-0 top-0 h-36 w-full", {
              "bg-fill-neutral-weak1": o && !(l && u),
              "left-auto w-1/2": !g && l,
              "right-auto w-1/2": !g && u
            })
          }
        ),
        /* @__PURE__ */ Z(
          "button",
          {
            className: I(
              "relative flex h-36 w-36 items-center justify-center rounded-full text-text-neutral-main typography-subtitle-16-bold",
              n ? "typography-subtitle-18-bold" : "typography-subtitle-16-bold",
              {
                invisible: g
              },
              {
                // TODO: sunday와 holiday 색상 확인 필요
                "!text-text-danger-main": m,
                "bg-background": o,
                "!text-static-white": l || u,
                "!cursor-not-allowed !opacity-30": d && !o,
                "cursor-pointer rounded-full border-2 border-solid border-line-neutral-weak2 bg-transparent opacity-100": !l && !u && !o && h
              },
              a
            ),
            disabled: d,
            onClick: k,
            type: "button",
            children: [
              /* @__PURE__ */ M("span", { className: "z-20", children: c }),
              l || u ? /* @__PURE__ */ M(
                Hn,
                {
                  className: I("absolute top-0 h-36 w-40", l ? "-left-1" : "-right-1"),
                  type: l ? "start" : "end"
                }
              ) : null
            ]
          }
        ),
        /* @__PURE__ */ M("span", { className: "flex h-15 flex-col items-center justify-center pt-2 text-text-neutral-sub typography-caption-11-regular", children: D })
      ]
    }
  );
};
Ze.displayName = "NDS.CalendarDay";
const Ln = me(Ze), ve = (t) => {
  const { id: e, month: n, days: a, year: r, dayDescriptions: i, isPc: c, showWeeks: s, className: f, styles: o, onSelectDate: l } = t, u = n.toString().padStart(2, "0"), h = E(
    () => Array.from({ length: a.length / 7 }, (d, m) => a.slice(m * 7, (m + 1) * 7)),
    [a]
  );
  return /* @__PURE__ */ Z("div", { className: I("w-full", f), id: e, style: o, children: [
    /* @__PURE__ */ M("div", { className: "relative flex items-center justify-center pt-1", children: /* @__PURE__ */ Z("span", { className: I(c ? "py-16 typography-subtitle-18-bold" : "py-12 typography-subtitle-16-bold"), children: [
      r,
      ".",
      u
    ] }) }),
    !!s && /* @__PURE__ */ M(Ge, { className: "mb-4" }),
    /* @__PURE__ */ M("div", { className: "flex w-full min-w-[280px] flex-col gap-6", role: "grid", children: h.map((d, m) => /* @__PURE__ */ M("div", { className: "grid w-full grid-cols-7 gap-0", children: d.map((g, D) => /* @__PURE__ */ M(
      Ln,
      {
        className: g.className,
        day: g,
        dayDescriptions: i,
        isPc: c,
        onSelectDate: l
      },
      `${r}-${n}-${D}`
    )) }, `${r}-${n}-${m}`)) })
  ] });
};
ve.displayName = "NDS.CalendarMonth";
const _n = me(ve), Un = {
  lessThanXSeconds: {
    one: "1초 미만",
    other: "{{count}}초 미만"
  },
  xSeconds: {
    one: "1초",
    other: "{{count}}초"
  },
  halfAMinute: "30초",
  lessThanXMinutes: {
    one: "1분 미만",
    other: "{{count}}분 미만"
  },
  xMinutes: {
    one: "1분",
    other: "{{count}}분"
  },
  aboutXHours: {
    one: "약 1시간",
    other: "약 {{count}}시간"
  },
  xHours: {
    one: "1시간",
    other: "{{count}}시간"
  },
  xDays: {
    one: "1일",
    other: "{{count}}일"
  },
  aboutXWeeks: {
    one: "약 1주",
    other: "약 {{count}}주"
  },
  xWeeks: {
    one: "1주",
    other: "{{count}}주"
  },
  aboutXMonths: {
    one: "약 1개월",
    other: "약 {{count}}개월"
  },
  xMonths: {
    one: "1개월",
    other: "{{count}}개월"
  },
  aboutXYears: {
    one: "약 1년",
    other: "약 {{count}}년"
  },
  xYears: {
    one: "1년",
    other: "{{count}}년"
  },
  overXYears: {
    one: "1년 이상",
    other: "{{count}}년 이상"
  },
  almostXYears: {
    one: "거의 1년",
    other: "거의 {{count}}년"
  }
}, jn = (t, e, n) => {
  let a;
  const r = Un[t];
  return typeof r == "string" ? a = r : e === 1 ? a = r.one : a = r.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? a + " 후" : a + " 전" : a;
}, An = {
  full: "y년 M월 d일 EEEE",
  long: "y년 M월 d일",
  medium: "y.MM.dd",
  short: "y.MM.dd"
}, Rn = {
  full: "a H시 mm분 ss초 zzzz",
  long: "a H:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, qn = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, zn = {
  date: te({
    formats: An,
    defaultWidth: "full"
  }),
  time: te({
    formats: Rn,
    defaultWidth: "full"
  }),
  dateTime: te({
    formats: qn,
    defaultWidth: "full"
  })
}, Bn = {
  lastWeek: "'지난' eeee p",
  yesterday: "'어제' p",
  today: "'오늘' p",
  tomorrow: "'내일' p",
  nextWeek: "'다음' eeee p",
  other: "P"
}, Vn = (t, e, n, a) => Bn[t], Xn = {
  narrow: ["BC", "AD"],
  abbreviated: ["BC", "AD"],
  wide: ["기원전", "서기"]
}, Qn = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1분기", "2분기", "3분기", "4분기"]
}, Gn = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: [
    "1월",
    "2월",
    "3월",
    "4월",
    "5월",
    "6월",
    "7월",
    "8월",
    "9월",
    "10월",
    "11월",
    "12월"
  ],
  wide: [
    "1월",
    "2월",
    "3월",
    "4월",
    "5월",
    "6월",
    "7월",
    "8월",
    "9월",
    "10월",
    "11월",
    "12월"
  ]
}, Zn = {
  narrow: ["일", "월", "화", "수", "목", "금", "토"],
  short: ["일", "월", "화", "수", "목", "금", "토"],
  abbreviated: ["일", "월", "화", "수", "목", "금", "토"],
  wide: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"]
}, Jn = {
  narrow: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  abbreviated: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  wide: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  }
}, Kn = {
  narrow: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  abbreviated: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  wide: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  }
}, ea = (t, e) => {
  const n = Number(t);
  switch (String(e == null ? void 0 : e.unit)) {
    case "minute":
    case "second":
      return String(n);
    case "date":
      return n + "일";
    default:
      return n + "번째";
  }
}, ta = {
  ordinalNumber: ea,
  era: H({
    values: Xn,
    defaultWidth: "wide"
  }),
  quarter: H({
    values: Qn,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: H({
    values: Gn,
    defaultWidth: "wide"
  }),
  day: H({
    values: Zn,
    defaultWidth: "wide"
  }),
  dayPeriod: H({
    values: Jn,
    defaultWidth: "wide",
    formattingValues: Kn,
    defaultFormattingWidth: "wide"
  })
}, na = /^(\d+)(일|번째)?/i, aa = /\d+/i, ra = {
  narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(기원전|서기)/i
}, sa = {
  any: [/^(bc|기원전)/i, /^(ad|서기)/i]
}, ia = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]사?분기/i
}, oa = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ca = {
  narrow: /^(1[012]|[123456789])/,
  abbreviated: /^(1[012]|[123456789])월/i,
  wide: /^(1[012]|[123456789])월/i
}, ua = {
  any: [
    /^1월?$/,
    /^2/,
    /^3/,
    /^4/,
    /^5/,
    /^6/,
    /^7/,
    /^8/,
    /^9/,
    /^10/,
    /^11/,
    /^12/
  ]
}, la = {
  narrow: /^[일월화수목금토]/,
  short: /^[일월화수목금토]/,
  abbreviated: /^[일월화수목금토]/,
  wide: /^[일월화수목금토]요일/
}, da = {
  any: [/^일/, /^월/, /^화/, /^수/, /^목/, /^금/, /^토/]
}, fa = {
  any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
}, ha = {
  any: {
    am: /^(am|오전)/i,
    pm: /^(pm|오후)/i,
    midnight: /^자정/i,
    noon: /^정오/i,
    morning: /^아침/i,
    afternoon: /^오후/i,
    evening: /^저녁/i,
    night: /^밤/i
  }
}, ma = {
  ordinalNumber: Re({
    matchPattern: na,
    parsePattern: aa,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: L({
    matchPatterns: ra,
    defaultMatchWidth: "wide",
    parsePatterns: sa,
    defaultParseWidth: "any"
  }),
  quarter: L({
    matchPatterns: ia,
    defaultMatchWidth: "wide",
    parsePatterns: oa,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: L({
    matchPatterns: ca,
    defaultMatchWidth: "wide",
    parsePatterns: ua,
    defaultParseWidth: "any"
  }),
  day: L({
    matchPatterns: la,
    defaultMatchWidth: "wide",
    parsePatterns: da,
    defaultParseWidth: "any"
  }),
  dayPeriod: L({
    matchPatterns: fa,
    defaultMatchWidth: "any",
    parsePatterns: ha,
    defaultParseWidth: "any"
  })
}, $e = {
  code: "ko",
  formatDistance: jn,
  formatLong: zn,
  formatRelative: Vn,
  localize: ta,
  match: ma,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, ga = 365, ya = 1, wa = "지금부터", Je = (t) => {
  const e = E(() => {
    var u;
    const [c, s] = [be(t.from), be(t.to)], f = Dt(s, c) + 1, o = Array.from({ length: f }, (h, d) => mt(c, d)), l = (u = t.holidays) == null ? void 0 : u.reduce(
      (h, d) => (h[d.toDateString()] = d, h),
      {}
    );
    return o.map((h) => {
      const d = be(h), m = Tt(h), g = Me(m, d) + 1, D = (T) => {
        const F = T.getDay(), U = l != null && l[T.toDateString()] ? "holiday" : (() => {
          switch (F) {
            case 0:
              return "sunday";
            case 6:
              return "saturday";
            default:
              return "weekday";
          }
        })();
        return {
          date: T.getDate(),
          dateType: U,
          dateObject: T
        };
      }, k = Array.from({ length: g }, (T, F) => J(d, F)).map(
        D
      ), y = k[0], v = [];
      for (let T = d.getDay(); T > 0 && y.dateObject; T--) {
        const F = J(y.dateObject, -T), U = T === 1 ? { ...y, date: F.getDate(), dateObject: F } : {};
        v.push({
          ...U,
          dateType: "empty"
        });
      }
      const N = [...v, ...k], w = 7 - N.length % 7, b = N[N.length - 1];
      if (w > 0 && w < 7)
        for (let T = 0; T < w; T++) {
          const F = T === 0 ? b : {};
          N.push({
            ...F,
            dateType: "empty"
          });
        }
      return {
        year: d.getFullYear(),
        month: d.getMonth() + 1,
        weekCount: Math.ceil(N.length / 7),
        days: N
      };
    });
  }, [t.from.toISOString(), t.to.toISOString(), t.holidays]), n = z(
    (c) => t.calendarType === "fromPastToNow" ? (s) => oe(s, c) || pe(s, c) : t.calendarType === "fromNowToFuture" ? (s) => De(s, c) || pe(s, c) : () => !0,
    [t.calendarType]
  ), a = E(() => {
    const c = t.today, s = n(c.getTime());
    return e.map((f) => {
      const o = f.days.map((l) => {
        const u = { ...l };
        if (u.dateType === "empty" || !u.dateObject)
          return u;
        const h = X(u.dateObject, c), d = s(u.dateObject.getTime()), m = oe(u.dateObject, t.from) && !h, g = De(u.dateObject, t.to);
        return u.disabled = !!u.disabled || m || g || !h && !d, t.useYanoljaTime && X(u.dateObject, Tn(c)) && (u.text = wa, u.disabled = !1), h && (u.isToday = !0), u;
      });
      return {
        ...f,
        days: o
      };
    });
  }, [t.from.toISOString(), t.to.toISOString(), t.useYanoljaTime, e]), r = E(() => {
    if (!t.selectedDate) return a;
    const [c, s] = t.selectedDate, f = !!c && ne(c, "MM", { locale: $e }), o = !!s && ne(s, "MM", { locale: $e });
    return c && !s ? a.map((l) => {
      const u = (m) => Me(m, c), h = (m) => {
        const g = u(m);
        return g < 0 ? !0 : g < (t.minDuration ?? ya) ? !1 : g <= (t.maxDuration ?? ga);
      }, d = l.days.map((m) => {
        const g = { ...m };
        return g.dateType === "empty" || g.disabled || !g.dateObject || (g.disabled = !h(g.dateObject), X(c, g.dateObject) && (g.isFirstSelected = !0, g.isLastSelected = !0, g.isSelected = !0)), g;
      });
      return {
        ...l,
        days: d
      };
    }) : c && s ? a.map((l) => {
      const u = l.days.map((h) => {
        const d = { ...h }, m = d.dateObject;
        return m && (d.isSelected = oe(m, s) && De(m, c), d.isFirstSelected = X(c, m), d.isLastSelected = d.dateType !== "empty" && X(s, m), (d.isFirstSelected || d.isLastSelected) && (d.isSelected = !0), d.dateType === "empty" && f === o && (d.isFirstSelected = !1, d.isLastSelected = !1, d.isSelected = !1)), d;
      });
      return {
        ...l,
        days: u
      };
    }) : a;
  }, [a, t.selectedDate, t.maxDuration, t.minDuration]);
  return {
    calendar: E(
      () => t.adjustCalendar ? t.adjustCalendar(r) : r,
      [t.adjustCalendar, r]
    )
  };
}, ba = 179, Da = 44, Ie = 51, Ta = 6, Sa = 16, Ma = 10, Ke = (t) => {
  const {
    deviceType: e,
    type: n = "range",
    calendarType: a = "fromNowToFuture",
    selectedDate: r,
    holidays: i,
    header: c,
    headerHeight: s = Ma,
    footer: f,
    options: o,
    className: l,
    monthClassName: u,
    onDateChange: h
  } = t, d = e === "etc", m = E(
    () => Be(ne((o == null ? void 0 : o.today) ?? G.tz("Asia/Seoul"), "yyyy-MM-dd")),
    [o == null ? void 0 : o.today]
  ), g = [m, J(m, 1)], D = r ?? g, k = le(null), [y, v] = ie([]), N = E(() => y.reduce((O, { height: C }) => O + (C || 0), 0), [y]), { calendar: w } = Je({
    from: (o == null ? void 0 : o.from) ?? m,
    to: (o == null ? void 0 : o.to) ?? J(m, (o == null ? void 0 : o.maxDaysCount) ?? ba),
    selectedDate: r,
    today: m,
    calendarType: a,
    holidays: i,
    useYanoljaTime: !!(o != null && o.useYanoljaTime),
    ...o
  }), b = z(
    (O) => {
      const [C, Y] = D;
      if (!O) return;
      const B = C && !Y && X(C, O), j = !C || D.every((P) => !!P), A = C && oe(O, C);
      if (B || j || A) {
        const P = [O, void 0];
        h == null || h(P, "startDate");
      } else {
        const P = [C, O];
        h == null || h(P, "endDate");
      }
    },
    [h, D]
  ), T = z(
    (O) => {
      switch (n) {
        case "single":
          F();
          break;
        case "range":
          b(O);
          break;
        case "both":
          U();
          break;
        default:
          throw new Error("Invalid calendar type");
      }
    },
    [b, n]
  ), F = (O) => {
  }, U = (O) => {
  };
  de(() => {
    !(r != null && r[0]) && !(r != null && r[1]) && (h == null || h(g, "initial"));
  }, []);
  const K = z(
    (O, C) => {
      const Y = [...y];
      Y[C].height = O, v(Y);
    },
    [y]
  );
  return ot(() => {
    const O = w.map(({ year: C, month: Y, days: B, weekCount: j }, A) => {
      const P = A === 0, W = j * Ie + // 주 단위 높이
      (j - 1) * Ta + Da + // 년월 제목
      Sa + // 월간 구분 공백
      (P ? s : 0);
      return {
        render: () => /* @__PURE__ */ M(
          _n,
          {
            className: I("pb-16", u),
            "data-index": A,
            dayDescriptions: o == null ? void 0 : o.dayDescriptions,
            days: B,
            id: `day-picker-${C}-${Y.toString().padStart(2, "0")}`,
            isPc: d,
            month: Y,
            onSelectDate: T,
            styles: {
              paddingTop: P ? `${s}px` : void 0
            },
            year: C
          },
          `${C}-${Y}`
        ),
        height: W
      };
    });
    v(O);
  }, [w, s]), de(() => {
    var R;
    if (!(r != null && r[0])) return;
    const O = r[0].getMonth() + 1, C = r[0].getFullYear(), Y = w.findIndex(($) => $.year === C && $.month === O);
    if (Y === -1) return;
    const B = 1.5, j = r[0].getDate(), { days: A } = w[Y], P = A.findIndex(($) => $.dateType !== "empty" && $.date === j), W = Math.max(Math.ceil(P / 7) - B, 0);
    (R = k.current) == null || R.scrollByItemIndex(Y, W * Ie);
  }, []), /* @__PURE__ */ M(
    Qe,
    {
      className: l,
      footer: f,
      header: c,
      items: y,
      listHeight: N,
      onScroll: t.onScroll,
      preLoadingThreshold: (o == null ? void 0 : o.preLoadingThreshold) ?? 400,
      scrollRef: k,
      updateHeight: K,
      updateInterval: (o == null ? void 0 : o.updateInterval) ?? 50
    }
  );
};
Ke.displayName = "NDS.DayPicker";
me(Ke);
const Oa = 179, et = (t) => {
  const {
    deviceType: e,
    type: n = "range",
    calendarType: a = "fromNowToFuture",
    selectedDate: r,
    holidays: i,
    footer: c,
    options: s,
    className: f,
    monthClassName: o,
    onChangePage: l,
    onChangeDate: u,
    customLastPageNode: h
  } = t, d = e === "etc", { pageSize: m = 2, adjustCalendar: g } = s ?? {}, [D, k] = ie(0), y = E(
    () => Be(ne((s == null ? void 0 : s.today) ?? G.tz("Asia/Seoul"), "yyyy-MM-dd")),
    [s == null ? void 0 : s.today]
  ), v = [y, J(y, 1)], N = r ?? v, { calendar: w } = Je({
    from: (s == null ? void 0 : s.from) ?? y,
    to: (s == null ? void 0 : s.to) ?? J(y, (s == null ? void 0 : s.maxDaysCount) ?? Oa),
    selectedDate: r,
    today: y,
    calendarType: a,
    holidays: i,
    useYanoljaTime: !!(s != null && s.useYanoljaTime),
    adjustCalendar: g,
    ...s
  }), b = Math.max(1, w.length - m + 1), T = D === 0, F = D === b - 1, U = E(() => h && D === b - 1 ? [...w.slice(D, D + m - 1), "__CUSTOM_LAST_PAGE_NODE__"] : w.slice(D, D + m), [w, D, m, b]), K = (P) => {
    const W = Math.max(0, Math.min(b - 1, P));
    k(W), l == null || l({
      currentPage: W,
      isFirst: W === 0,
      isLast: W === b - 1
    });
  }, O = () => {
    K(D - 1);
  }, C = () => {
    K(D + 1);
  }, Y = z(
    (P) => {
      const [W, R] = N;
      if (!P) return;
      const $ = W && !R && X(W, P), ye = !W || N.every((ae) => !!ae), tt = W && oe(P, W);
      if ($ || ye || tt) {
        const ae = [P, void 0];
        u == null || u(ae, "startDate");
      } else {
        const ae = [W, P];
        u == null || u(ae, "endDate");
      }
    },
    [u, N]
  ), B = z(
    (P) => {
      switch (n) {
        case "single":
          j();
          break;
        case "range":
          Y(P);
          break;
        case "both":
          A();
          break;
        default:
          throw new Error("Invalid calendar type");
      }
    },
    [Y, n]
  ), j = (P) => {
  }, A = (P) => {
  };
  return de(() => {
    !(r != null && r[0]) && !(r != null && r[1]) && (u == null || u(v, "initial"));
  }, []), /* @__PURE__ */ Z("div", { className: I("relative", f), children: [
    /* @__PURE__ */ Z("div", { className: "absolute -top-2 z-10 flex w-full justify-between", children: [
      /* @__PURE__ */ M(
        Pe,
        {
          "aria-label": "이전 달",
          className: T ? "invisible" : "",
          icon: /* @__PURE__ */ M(ct, {}),
          onClick: O,
          size: "large",
          theme: "ghost"
        }
      ),
      /* @__PURE__ */ M(
        Pe,
        {
          "aria-label": "다음 달",
          className: F ? "invisible" : "",
          icon: /* @__PURE__ */ M(ut, {}),
          onClick: C,
          size: "large",
          theme: "ghost"
        }
      )
    ] }),
    /* @__PURE__ */ M("div", { className: "flex w-full gap-20 overflow-hidden", children: U.map((P, W) => {
      if (typeof P == "string")
        return /* @__PURE__ */ M("div", { className: "w-full", children: h }, "last-page-node");
      const { year: R, month: $, days: ye } = P;
      return /* @__PURE__ */ M("div", { className: "w-full", children: /* @__PURE__ */ M(
        ve,
        {
          className: I(o),
          "data-index": W + D * m,
          dayDescriptions: s == null ? void 0 : s.dayDescriptions,
          days: ye,
          id: `day-picker-${R}-${$.toString().padStart(2, "0")}`,
          isPc: d,
          month: $,
          onSelectDate: B,
          showWeeks: !0,
          year: R
        }
      ) }, `${R}-${$}`);
    }) }),
    /* @__PURE__ */ M("div", { className: "mt-16", children: c })
  ] });
};
et.displayName = "NDS.DayPickerPagination";
me(et);
export {
  Ke as D,
  et as a,
  Ge as b,
  Je as u
};
